export const PAGE_RULES_MAX_ENTRIES = 50;
export const PAGE_RULES_MAX_LENGTH = 200;

const PAGE_PATH = /^\/[\w\-./*]*$/;

export type PageListError =
  | { code: 'invalid' | 'too_long' | 'duplicate'; entry: string }
  | { code: 'too_many'; entry?: undefined };

/** One path per line. Blank lines are dropped, so an emptied textarea reaches the wire as `[]`. */
export const parsePageList = (text: string | undefined): string[] =>
  (text ?? '')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

export const toPageListText = (list: string[] | null | undefined): string =>
  (list ?? []).join('\n');

/**
 * Mirrors the orchestrator's `pageList` Joi schema, so a save never bounces on
 * a rule the form could have shown first.
 */
export const validatePageList = (text: string | undefined): PageListError | undefined => {
  const entries = parsePageList(text);
  if (entries.length > PAGE_RULES_MAX_ENTRIES) {
    return { code: 'too_many' };
  }
  const seen = new Set<string>();
  for (const entry of entries) {
    if (entry.length > PAGE_RULES_MAX_LENGTH) {
      return { code: 'too_long', entry };
    }
    if (!PAGE_PATH.test(entry)) {
      return { code: 'invalid', entry };
    }
    const key = entry.toLowerCase();
    if (seen.has(key)) {
      return { code: 'duplicate', entry };
    }
    seen.add(key);
  }
  return undefined;
};
